import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { tickerFormatter } from '../../utils/charts-common.js';

const OverspeedsBySeverity = ({
  chartData, legend, grouping, intl, startDate, endDate,
}) => (
  <ResponsiveContainer debounce={1000}>
    <BarChart
      data={chartData}
      margin={{
            top: 5, right: 30, left: 20, bottom: 5,
          }}
    >
      <CartesianGrid strokeDasharray="3 3" vertical={false} />
      <XAxis
        dataKey="group"
        tickFormatter={tickerFormatter(intl)(grouping, startDate, endDate)}
      />
      <YAxis
        label={{
              value: intl.formatMessage({ id: 'stats.charts.numberOfOverspeeds' }),
              angle: -90,
              position: 'insideBottomLeft',
            }}
      />
      {legend &&
        <Legend
          verticalAlign="middle"
          layout="vertical"
          align="right"
        />
      }
      <Tooltip labelFormatter={tickerFormatter(intl)(grouping, startDate, endDate)} />
      <Bar dataKey="overspeeds.small" fill="#f7e483" name={intl.formatMessage({ id: 'journeyDetails.severity.small' })} />
      <Bar dataKey="overspeeds.medium" fill="#f7b984" name={intl.formatMessage({ id: 'journeyDetails.severity.medium' })} />
      <Bar dataKey="overspeeds.large" fill="#f08d80" name={intl.formatMessage({ id: 'journeyDetails.severity.large' })} />
      <Bar dataKey="overspeeds.xlarge" fill="#737b82" name={intl.formatMessage({ id: 'journeyDetails.severity.xlarge' })} />
    </BarChart>
  </ResponsiveContainer>
);
OverspeedsBySeverity.propTypes = {
  intl: intlShape.isRequired,
  chartData: PropTypes.array.isRequired,
  grouping: PropTypes.string.isRequired,
  legend: PropTypes.bool,
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
};


export default injectIntl(OverspeedsBySeverity);



// WEBPACK FOOTER //
// ./src/components/Stats/OverspeedsBySeverity.js